import { cn } from "@/lib/utils";

const TONE_MAP = {
  healthy: "bg-status-healthy/15 text-status-healthy border-status-healthy/40",
  low: "bg-status-low/15 text-status-low border-status-low/50",
  critical: "bg-status-critical/15 text-status-critical border-status-critical/40",
  "in-transit": "bg-status-in-transit/15 text-status-in-transit border-status-in-transit/40",
  muted: "bg-muted text-muted-foreground border-border",
};

const DOT_MAP = {
  healthy: "bg-status-healthy",
  low: "bg-status-low",
  critical: "bg-status-critical",
  "in-transit": "bg-status-in-transit",
  muted: "bg-muted-foreground/40",
};

export function StatusBadge({ tone = "muted", children, dot = true, className, ...props }) {
  return (
    <span className={cn("status-pill border", TONE_MAP[tone], className)} {...props}>
      {dot && <span className={cn("inline-block w-1.5 h-1.5 rounded-full", DOT_MAP[tone])} />}
      {children}
    </span>
  );
}
